import { render } from "./CopyCode.vue?vue&type=template&id=2b3d384a"
import script from "./CopyCode.vue?vue&type=script&lang=js"
export * from "./CopyCode.vue?vue&type=script&lang=js"

import "./CopyCode.vue?vue&type=style&index=0&id=2b3d384a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__